<template>
  <div class="container   px-4 mt-24 mx-auto text-gray-600">
    <h1>Preise</h1>
    <span class="flex flex-col lg:flex-row">
      <div v-for="price in prices" :key="price.index" class="w-full">
        <PriceCard
          :prices="price[0].value.length ? price[0].value : null"
          :price="!price[0].value.length ? price[0].value : null"
          :name="price[0].name"
          :description="price[0].description"
          class="mr-2 mb-4 h-full"
        />
      </div>
    </span>
  </div>
</template>

<script>
import PriceCard from '../components/PriceCard.vue'

export default {
  name: 'Pricing',
  components: { PriceCard },
  data() {
    return {
      prices: {
        haus: [
          {
            name: 'Ganzes Haus',
            value: 400,
            description:
              'Pauschale für das ganze Haus komplett inkl. Strom, Wasser',
          },
        ],
        zimmer: [
          {
            name: 'Zimmer',
            value: [
              { name: 'Kinder', value: 10, description: '(6 bis 15 Jahre)' },
              {
                name: 'Erwachsene',
                value: 12,
                description: '(ab 16 Jahren)',
              },
            ],
            description: 'Zimmer in der 2. Etage',
          },
        ],
        lager: [
          {
            name: 'Lager',
            value: [
              { name: 'Kinder', value: 10, description: '(6 bis 15 Jahre)' },
              { name: 'Erwachsene', value: 12, description: '(ab 16 Jahren)' },
            ],
            description: 'Lager in der 3. Etage',
          },
        ],
      },
    }
  },
}
</script>
